import { MUTATE } from '@/store/modules/mutation_types';

export function setPeriod({ commit }, { selectedPeriod }) {
  commit(MUTATE, {
    property: 'activePeriod',
    with: selectedPeriod,
  });
}
